import React from 'react';
import { Loader2 } from 'lucide-react';

export default function MetricCard({ 
  title, 
  icon, 
  children, 
  isLoading = false 
}) {
  return (
    <div className="bg-white rounded-xl shadow-md p-6 hover:shadow-lg transition-shadow duration-200">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-medium text-midnight font-heading">{title}</h3>
        <div className="text-ebony">{icon}</div>
      </div>
      
      {isLoading ? (
        <div className="flex items-center justify-center h-20">
          <Loader2 className="w-6 h-6 animate-spin text-violet" />
        </div>
      ) : (
        <div className="space-y-2">
          {children}
        </div>
      )}
    </div>
  );
}